<template>
  <div class="product-wrapper df fdc aifs f1 w100p">

<!--     <div class="top-bar-global w100p _position1 df jcsb aic breadcrumb-wrapper">
      <div class="breadcrumb df">
        <h2 class="breadcrumb-other" @click="goTo('/me')">Home</h2>
        <h2 class="breadcrumb-separator">-</h2>
        <h2>User Settings</h2>
      </div>
      <div class="previews df jcsb aic">
      </div>
    </div> -->

    <div class="whole-page-box-global-2 whole-page-box-global-2-unset w100p">


      <div class="digital-download-details df jcsb aifs f1">
        <!-- <div class='df fdc'>
          <div v-if="profileImageUrl" class="dropzone-wrapper image-dropzone-wrapper posrel df fdc aic jcc">
            <img class="image-uploaded" :src="profileImageUrl">
            <a class="w100p tac image-uploaded-under" @click="removeProductImage()">Remove Image</a>
          </div>
          <div v-else class="dropzone-wrapper image-dropzone-wrapper posrel o05">
            <vue-dropzone ref="myVueDropzone" 
                    id="dropzone-a"
                    class="image-upload"
                    @vdropzone-file-added="uploadedProductImage"
                    :options="dropzoneOptions">
            </vue-dropzone>
            <div class="dropzone-overlay df fdc">
              <p>Drag Profile Image Here</p>
              <p>or</p>
              <a class="button-b df aic jcc">Upload File</a>
            </div>
          </div>
          <div v-if="$store.getters['AUTH.email']" class='your-email'>
            <p>Your email:</p>
            <p>{{$store.getters['AUTH.email']}}</p>
          </div>
        </div> -->
        <div class="product-basics f1 df fdc">

<!--           <div class="df w100p jcsb product-detail-outer">
            <div class="product-detail f1">
              <h4>Full Name</h4>
              <input disabled="true" placeholder="Your Full Name" v-model="fullName" type="" name="">
            </div>
          </div> -->
        
          <h3>Profile ({{$store.getters['AUTH.email']}})</h3>
          <div class="product-detail f1 df fdc">
            <h4>Display Name</h4>
              <input placeholder="You/Company Display Name" v-model="displayName" type="" name="">
          </div>
          <h3>Change Your Password</h3>
          <div class="df w100p product-detail-outer">
            <div class="product-detail f1">
              <h4>Current Password</h4>
              <input placeholder="Password" v-model="currentPassword" type="" name="">
            </div>
            <div class="product-detail f1">
            </div>
          </div>
          <div class="df w100p product-detail-outer">
            <div class="product-detail f1">
              <h4>New Password</h4>
              <input placeholder="Password" v-model="newPassword" type="" name="">
            </div>
            <div class="product-detail f1">
              <h4>Confirm Password</h4>
              <input placeholder="Confirm Password" v-model="newPasswordConfirm" type="" name="">
            </div>
          </div>
          <p class="auth-error" v-if="error">{{error}}</p>

          <div class="product-detail _s2 df">
            <!-- <button class="just-save" @click="saveProfile()">Reset</button> -->
            <a class="button-1 save-button" @click="saveProfile(true)">Save</a>
            <!-- <button @click="deactivateProduct()" v-else>De-Activate</button> -->
          </div>

        </div>
      </div>
    </div>

    <div class="whole-page-box-global-2 whole-page-box-global-2-unset w100p _s1">


      <div class="digital-download-details df jcsb aifs f1">

        <div v-if="$store.getters['AUTH.myPrivateData'].type !== 'pro'" class="product-basics f1 df fdc">  

<!--           <div class="df w100p jcsb product-detail-outer">
            <div class="product-detail f1">
              <h4>Full Name</h4>
              <input disabled="true" placeholder="Your Full Name" v-model="fullName" type="" name="">
            </div>
          </div>
          <div class="product-detail f1 df fdc">
            <h4>Display Name</h4>
              <input disabled="true" placeholder="You/Company Display Name" v-model="displayName" type="" name="">
          </div> -->
          <div class="plan-title-block df fdc">
            <h2 class="line-3">Get CupWise Pro</h2>
            <p class="line-2 w100p">
            CupWise gives you the tools to engage your audience and get breakthrough taste data insights. Host your own cuppings, integrate into your website and use CupWise as your go-to cupping tool!</p>
          </div>
          <div class="df w100p product-detail-outer">
            <div class="">
              <div class="pricing-plan curp" @click="goTo('/?auth=pro&pro=getpro')">
                <div class="pricing-plan-header pricing-1">
                  <p class="pricing-plan-header-name">Pro</p>
                  <hr/>
                  <p class="pricing-plan-header-price">$24.99/month</p>
                  <p class="pricing-plan-header-subheading">Unlimited Cuppings</p>
                </div>
                <div class="f1"></div>
                <div class="pricing-plan-box highlighted-plan hp1">
                  <span class="pricing-plan-two-liner">
                    <p>Up to 1000 Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>30 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p>Host your own cuppings</p>
                  <!-- <p>Chat, video, and more</p> -->
                  <!-- <p>Template Editor</p> -->
                  <p>CupWise template library</p>
                  <p>Cupping statistics</p>
                  <p>Embeddable</p>
                  <p>Live onboarding</p>
                  <p>E-mail support</p>
                  <p class="try-it-free">Try it free for 7 days!</p>
                  <a class="button-1">Get Started</a>
                  <!-- <a class="button-1" @click="goTo('/get/pro')">Get Started</a> -->
                </div>  
              </div>            
            </div>
          </div>
          <!-- <p class="logout curp" @click="logout()">Logout</p> -->
<!--           <p v-if="this.productType == 'digital-download'" class="reference">The customer will be asked to provide their e-mail address.</p>
          <p v-else-if="this.productType == 'digital-service'" class="reference">The customer will be asked to provide their e-mail address and upload reference files.</p>
          <p v-else-if="this.productType == 'calendar-event'" class="reference">The customer will be asked to select a time to book an appointment.</p>
          <div class="product-detail df" v-if="this.productType == 'digital-download'">
            <div class="check-fulfillment">
              <input v-model="addFile" type="checkbox" class="check-fulfillment-box" name="">
            </div>
            <div class="check-detail f1">
              <h4>Send File</h4>
              <p class="sub-line">Files will be sent automatically after purchase</p>
              <div v-if="productDeliveryFile" class="product-delivery-file dropzone-wrapper posrel">
                <div class="df fdc aic jcc">
                  <img class="file-icon" src="../../static/images/file-icon.png">
                  <p class="file-text">
                    {{productDeliveryFile.name}}
                  </p>
                  <a class="file-remove-text" @click="removeProductDeliveryFile()">Remove File</a>
                </div>
              </div>
              <div v-else class="dropzone-wrapper posrel">
                <vue-dropzone ref="myVueDropzone" 
                        id="dropzone"
                        class="file-upload"
                        @vdropzone-file-added="uploadedProductDeliveryFile"
                        :options="dropzoneOptions2">
                </vue-dropzone>
                <div class="dropzone-overlay df fdc">
                  <p>Drag File Here</p>
                  <p>or</p>
                  <a class="button-b df aic jcc">Upload File</a>
                </div>
              </div>
            </div>
          </div>
          <div v-if="productType == 'calendar-event'" class="product-detail df">
            <div class="check-detail f1">
              <h4>My Availability</h4>
              <p class="sub-line">When would you like to take this appointment?</p>
              <div class="my-availability df fdc">
                <div class="one-day df jcsb w100p aic" v-for="(day, i) in [
                  'Monday',
                  'Tuesday',
                  'Wednesday',
                  'Thursday',
                  'Friday',
                  'Saturday',
                  'Sunday',
                ]">
                  <p class="f1">{{day}}</p>
                  <p>From</p>
                  <select v-model="calendarFrom[i]" class="r0 r1">
                    <option>12 am</option>
                    <option>1 am</option>
                    <option>2 am</option>
                    <option>3 am</option>
                    <option>4 am</option>
                    <option>5 am</option>
                    <option>6 am</option>
                    <option>7 am</option>
                    <option>8 am</option>
                    <option>9 am</option>
                    <option>10 am</option>
                    <option>11 am</option>
                    <option>12 pm</option>
                    <option>1 pm</option>
                    <option>2 pm</option>
                    <option>3 pm</option>
                    <option>4 pm</option>
                    <option>5 pm</option>
                    <option>6 pm</option>
                    <option>7 pm</option>
                    <option>8 pm</option>
                    <option>9 pm</option>
                    <option>10 pm</option>
                    <option>11 pm</option>
                  </select>
                  <p>to</p>
                  <select v-model="calendarTo[0]" class="r1">
                    <option>12 am</option>
                    <option>1 am</option>
                    <option>2 am</option>
                    <option>3 am</option>
                    <option>4 am</option>
                    <option>5 am</option>
                    <option>6 am</option>
                    <option>7 am</option>
                    <option>8 am</option>
                    <option>9 am</option>
                    <option>10 am</option>
                    <option>11 am</option>
                    <option>12 pm</option>
                    <option>1 pm</option>
                    <option>2 pm</option>
                    <option>3 pm</option>
                    <option>4 pm</option>
                    <option>5 pm</option>
                    <option>6 pm</option>
                    <option>7 pm</option>
                    <option>8 pm</option>
                    <option>9 pm</option>
                    <option>10 pm</option>
                    <option>11 pm</option>
                  </select>

                </div>
              </div>
            </div>
          </div>
          <div v-if="productType == 'calendar-event'" class="product-detail df">
            <div class="check-detail max-detail f2">
              <h4>Timezone</h4>
              <select v-model="myTimezone" class="">
                <option v-for="(item, i) in allTimezones">
                  {{item.label}}
                </option>
              </select>
            </div>
            <div class="check-detail f1">
              <h4>Appointment Length</h4>
                  <select v-model="appointmentLength" class="">
                    <option>15 minutes</option>
                    <option>30 minutes</option>
                    <option>45 minutes</option>
                    <option>1 hour</option>
                    <option>2 hours</option>
                    <option>half day</option>
                    <option>full day</option>
                  </select>
            </div>
          </div>
          <div class="product-detail df">
            <div class="check-fulfillment">
              <input v-model="addURL" type="checkbox" class="check-fulfillment-box" name="">
            </div>
            <div class="check-detail f1">
              <h4>Redirect to url</h4>
              <p class="sub-line">The customer will be redirected to the URL after purchase</p>
              <input placeholder="http://" v-model="redirectURL" class="mw2" type="" name="">
            </div>
          </div> -->
        </div>
        <div class="product-basics f1 df fdc" v-else>
          <div class="pricing-plan pricing-plan-2 curp">
                <div class="pricing-plan-header pricing-plan-header-2 pricing-1">
                  <p class="pricing-plan-header-name">CupWise Pro</p>
                </div>
                <div class="f1"></div>
                <div class="pricing-plan-box pricing-plan-box-2 highlighted-plan">
                  <p class="pricing-plan-header-subheading"></p>
                  <!-- <span class="pricing-plan-two-liner"> -->
                    <!-- <p>0/10 Sessions</p> -->
                    <!-- <p>Per cupping</p> --> 
                  <!-- </span> -->
                  <span class="pricing-plan-two-liner">
                    <p>Up to 1000 Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>30 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p>Trial ends on {{formatDate($store.getters['AUTH.myPrivateData'].trialEnd)}}</p>
                  <div class="f1"></div>
                  <!-- <a class="button-1" @click="goTo('/get/pro')">Get Started</a> -->
                </div>

                <p class="curp" @click="cancelSubscription()">Cancel subscription</p>  
              </div>  

          <!-- Cup           You plan - pro. Trial ends on ____. Next billing date: ____. Cancel. -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import router from '@/router'

import common from '@/util/common'
import products from '@/util/products'
import LandingProduct from '@/components/LandingProduct'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'Settings',
  data () {
    return {
      error: '',
      dropzoneOptions: {
          autoProcessQueue: false,
          url: 'https://',
          thumbnailWidth: 150,
          maxFilesize: 1,
          // headers: { "My-Awesome-Header": "header value" },
          // dictDefaultMessage: 'Check',
          // previewTemplate: document.querySelector('#template-container').innerHTML
          dictDefaultMessage: ``
      },
      loading: false,
      profileImageUrl: '',
      fullName: '',
      displayName: '',
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: ''
    }
  },
  props: ['feel'],
  components: {
    LandingProduct,
    vueDropzone: vue2Dropzone
  },
  methods: {
    formatDate (d) {
      let date = new Date(d)
      return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
    },
    cancelSubscription () {
      let go = confirm('Are you sure you want to cancel your subscription?')
      if (go) {
        this.$store.dispatch('AUTH.cancelSubscription', {})
      }
    },
    goTo (route) {
      router.push(route)
      window.scrollTo(0,0)
    },
    logout () {
      this.$store.dispatch('AUTH.logout', {})
    },
    changePrice (e) {
      let price = e.target.value
      console.log('price', price)
      this.price = price * 100
    },
    newOrEdit () {
      if (this.uniqueProductId) {
        return 'Edit '
      }
      return 'New '
    },
    productTypeDisplay () {
      let type = this.productType
      if (type == 'digital-download') {
        return 'Digital Download'
      } else if (type == 'digital-service') {
        return 'Service'
      } else if (type == 'calendar-event') {
        return 'Calendar Invite'
      }
      return ''
    },
    saveProfile (activate) {
      let productObject = {
        profileImageUrl: this.profileImageUrl,
        fullName: this.fullName,
        displayName: this.displayName,
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
        newPasswordConfirm: this.newPasswordConfirm,
      }

      this.$store.dispatch('AUTH.saveProfile', productObject).then((res) => {
        let product = res
        console.log('profile', res)
        this.error = res.message
        // ,,, set error
      })
    },
    setNewPassword () {
      this.$store.dispatch('AUTH.setNewPassword', {p: this.currentPassword, p2: this.newPassword}).then((res) => {
        console.log('password changed')
        if (res == 'ok') {
          this.currentPassword = ''          
          this.newPassword = ''          
          this.newPasswordConfirm = ''          
        }
        // let product = res
        // console.log('profile', res)
      })
    },
    removeProductImage () {
      this.profileImageUrl = ''
    },
    removeProductDeliveryFile () {
      this.productDeliveryFile = ''
    },
    uploadedProductImage (file) {
      let item = {
        uid: this.$store.getters['AUTH.uid'],
        file
      }
      this.$store.dispatch('AUTH.uploadProfileImage', item).then((res) => {
        this.productImageUrl = res.url
      })
    },
    generateNewInternalProductId () {
    },
    loadProfile () {
      console.log('loaded********...')
      if (this.$store.getters['AUTH.myPublicData'].loaded) {
        this.displayName = this.$store.getters['AUTH.myPublicData'].displayName
      } else {
        setTimeout(() => {
          this.loadProfile()
        }, 500)
      }
    },
    loadProfile2 () {
      console.log('loaded********...')
      if (this.$store.getters['AUTH.myPrivateData'].loaded) {
        this.fullName = this.$store.getters['AUTH.myPrivateData'].name
      } else {
        setTimeout(() => {
          this.loadProfile2()
        }, 500)
      }
    }
  },
  computed: {
  },
  watch: {
  // '$route.params': {
  //     handler: function (params) {
  //       let id = params.id
  //        if (id) {
  //         this.getProductData()
  //        } else {
  //         this.loadDefaultProduct()
  //        }
  //     },
  //     // deep: true,
  //     immediate: true
  //   }
  },
  created () {
    this.loadProfile()
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  ._position1 {
  }

  h1 {
    text-transform: capitalize;
  }

  h2 {
    /*font-size: 24px;*/
    /*font-weight: 500;*/
    /*font-family: 'Rubik', 'sans-serif';*/
    /*letter-spacing: .04em !important;*/
    color: #2b2b2b;
  }

  h3 {
    margin-bottom: 18px;
    text-align: left;
    /*color: #5469d4;*/
  }

  h3 {
    /*color: $color-primary;*/
    /*padding-left: 10px;*/
    color: #5C5C5C;
    font-family: Inter;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 21px;
    .icon {
      margin-right: 6px;
    }
  }
  hr {
    margin-bottom: 45px;
  }

  .product-wrapper {
    /*background-color: #292929;*/
    padding: 15px;
    margin-top: 0px;
    padding-top: 0;
  }
  .product-splash, .product-choose-your-feel {
    width: 100%;
    height: 566px;
    margin-bottom: 120px;
  }
  .product-products {
    flex-wrap: wrap;
  }
  .product-product-image {
    width: 515px;
    min-width: 515px;
    height: 566px;
  }
  .top-bar-global {
    /*height: 68px;*/
  }
  .whole-page-box-global {
  }
  $image-upload-size: 200px;
  .image-upload {
    width: $image-upload-size;
    height: $image-upload-size;
    border-radius: 6px;
    /*padding: 12px;*/
    border: 1px dashed rgba(50, 50, 93, 0.1);
    font-size: 16px;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
      & + .dropzone-overlay {
        background-color: #fdfdfd;
        border: 1px dashed rgba(50, 50, 93, 0.12);
        
        a {
          background-color: #5469d4;
          color: $color-white;
        }
      }
    }

    & > * {
      margin: 0 !important;
    }
  }
  .image-uploaded {
    width: $image-upload-size;
    height: $image-upload-size;
    border-radius: 6px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    object-fit: cover;
  }
  .image-uploaded-under {
    margin-top: 6px;
    font-size: 12px;
  }
  .file-upload {
    width: 100%;
    /*max-width: 500px;*/
    height: 150px;
    border-radius: 6px;
    /*padding: 12px;*/
    border: 1px dashed rgba(50, 50, 93, 0.1);
    font-size: 16px;
    background: white;
    /*margin-right: 20px;*/
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
      & + .dropzone-overlay {
        background-color: #fdfdfd;
        border: 1px dashed rgba(50, 50, 93, 0.12);
        
        a {
          background-color: #5469d4;
          color: $color-white;
        }
      }
    }
  }
  .product-delivery-file {
    & > div {
      border: 1px solid rgba(50, 50, 93, 0.1);
      border-radius: 6px;
      width: 100%;
      height: 150px;
    }
  }
  .dropzone-overlay {
    border-radius: 10px;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    /*background-color: #aaa;*/
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
/*    background-color: #fbfbfb;
    border: 1px dashed rgba(50, 50, 93, 0.12);*/

    p, {
      font-size: 14px;
      margin-bottom: 6px;
    }

  }
  .product-basics {
    /*height: 200px;*/
    /*min-height: 200px;*/
  }
  textarea {
    border-radius: 6px;
    padding: 12px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    height: 44px;
    font-size: 16px;
    width: 100% !important;
    background: white;
    margin-bottom: 6px;
  }
  .digital-download-details {
    height: 100%;
  }
  .product-detail {
    margin-bottom: 20px;
    max-width: 500px;

    &:last-child {
      margin-right: 0 !important;
    }
  }
  .product-detail-outer {
    max-width: 500px;

    & > .product-detail {
      /*flex: 1;*/
      &:first-child {
        /*flex: 2;*/
        margin-right: 20px;
      }
    }
  }
  $placeholderColor: #898989;
  h4 {
    font-family: 'Rubik', 'sans-serif';
    font-size: 14px;
    letter-spacing: 0.2px;
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: rgb(43, 43, 43);
  }
  input, textarea, select {
    max-width: 540px;
    border-color: #efefef !important;
    background-color: #fff;
    font-size: 14px;
    padding: 12px 10px;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: 'Rubik', 'sans-serif';
    color: rgb(43, 43, 43);


    ::-webkit-input-placeholder { /* Edge */
      color: $placeholderColor;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: $placeholderColor;
    }

    ::placeholder {
      color: $placeholderColor;
    }
  }
  .sub-line {
    margin-bottom: 8px;
  }
  .check-fulfillment {
    margin-right: 20px;

    input {
      width: 20px;
    }
  }
  .check-fulfillment-box {
    display: flex;
    flex-direction: column;
    height: 20px;
    margin: 0;
  }
  .mw2 {
    /*max-width: 500px;*/
  }
  .mw3 {
    /*max-width: 500px;*/
  }
  .just-save {
    background-color: transparent;
    box-shadow: none;
    color: #2b2b2b;
  }
  .button-b {
    border: 1px solid #5469d4;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #5469d4;
    padding: 2px 6px;
    height: 30px;

    &:hover {
      border: 1px solid transparent;
      background-color: #5469d4;
      color: $color-white;
    }
  }
  .image-dropzone-wrapper {
    margin-right: 20px;
  }
  .file-icon {
    opacity: 0.5;
    height: 35px;
    margin-bottom: 10px;
  }
  .file-text {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .file-remove-text {
    font-size: 10px;
    text-decoration: underline;
  }
  .r0 {
    margin-right: 10px;
  }
  .r1 {
    margin-left: 10px;
  }
  .one-day {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .max-detail {
    /*max-width: 350px;*/
    select {
      max-width: 300px;
    }
  }
  .reference {
    margin-top: 4px;
    font-size: 12px;
    margin-bottom: 12px;
  }
  .previews {
    div {
      a {
        font-size: 14px;
        color: #444;
      }
    }
  }
  .your-email {
    margin-top: 15px;
    p {
      font-family: 'CA SaygonText', sans-serif;
      font-size: 16px;
      font-weight: 400;

      &:first-child {
        font-size: 12px;
      }
    }
  }
  .placeholder-detail {
    width:: 100%;
    height: 50px;
    background-color: #e0e0e088;
  }
  input[disabled], .o05 {
    background-color: #f2f2f2;
    pointer-events: none;
    border-radius: 5px;

    & > * {
      background-color: #f2f2f2;
      border-radius: 5px;
    }
  }

  @media (max-width: 1000px) {
    .digital-download-details {
      flex-direction: column;
    }
    .product-basics {
      /*margin-top: 24px;*/
      width: 100%;
    }
  }
  @media (max-width: 500px) {
    .product-detail-outer {
      flex-direction: column;

      & > * {
        margin-right: 0 !important;
      }
    }
  }
  @media (max-width: 400px) {
    .product-wrapper {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  @media (max-width: 420px) {
    .product-wrapper {
      padding-left: 0;
      padding-right: 0;
    }

    .whole-page-box-global {
      border-radius: 0;
    }
  }
  .save-button {
    /*margin-bottom: 30px;*/
  }
  ._s1 {
    margin-top: 20px;
  }
  ._s2 {
    margin-bottom: 0px;
  }
  .auth-error {
    color: red;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .line-2 { 
    color: #000000;
    font-family: Inter;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20px;
    margin-top: 16px;
    margin-bottom: 24px;

    .highlight {
      color: #27C8B3;
      font-size: 20px;
      font-weight: 500;
    }
  }
  .line-3 {
    color: #000000;
    font-family: Inter;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 39px;
    margin-bottom: 8px;
  }
  .plan-title-block {
    margin-bottom: 25px;
  }
  .pricing-plan-2 {
    height: unset;
    padding-left: 15px;
    padding-right: 15px;
    margin-left: 0 !important;
  }
  .pricing-plan-box-2 {
    height: unset;
    margin-top: 25px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .pricing-plan-header-2 {
    height: unset;
    padding: 10px;
  }

  .hp1 {
    height: unset;
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Settings.vue